module.exports = __webpack_public_path__ + "assets/media/defaultAppIcon.951fda95.svg";